export const preDefaultStepCode = "Pre-default-notice-sent"
export const preDefaultClosedStepCode = "Defaultnolongerrequired"
export const defaultStepCode = "AccountinDefault"
export const preSatisfiedDefaultStepCode = "DefaultPresatisfied"
export const preSatisfiedDefaultClosedStepCode = "Defaultsatisfied"
